import { useIntl } from "react-intl";
import { StatCard } from "@lendcord/concord";
import { useGetPeopleDirectoryCountsQuery } from "../api/people.api";

export function PeopleCounts() {
  const intl = useIntl();
  const { data, isLoading } = useGetPeopleDirectoryCountsQuery();

  const borrower = data?.counts.BORROWER;
  const lender = data?.counts.LENDER;

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
      <StatCard label={intl.formatMessage({ id: "lender.people.borrowerTotalLabel" })} value={String(borrower?.total ?? 0)} loading={isLoading} />
      <StatCard label={intl.formatMessage({ id: "lender.people.borrowerPendingLabel" })} value={String(borrower?.pending ?? 0)} loading={isLoading} />
      <StatCard label={intl.formatMessage({ id: "lender.people.borrowerApprovedLabel" })} value={String(borrower?.approved ?? 0)} loading={isLoading} />
      <StatCard label={intl.formatMessage({ id: "lender.people.lenderTotalLabel" })} value={String(lender?.total ?? 0)} loading={isLoading} />
      <StatCard label={intl.formatMessage({ id: "lender.people.lenderPendingLabel" })} value={String(lender?.pending ?? 0)} loading={isLoading} />
      <StatCard label={intl.formatMessage({ id: "lender.people.lenderApprovedLabel" })} value={String(lender?.approved ?? 0)} loading={isLoading} />
    </div>
  );
}
